import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=4f3dc72c"
import script from "./ErrorHandler.vue?vue&type=script&lang=ts"
export * from "./ErrorHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports